import { render, staticRenderFns } from "./teacher-salary.vue?vue&type=template&id=47a04152&scoped=true"
import script from "./teacher-salary.vue?vue&type=script&lang=js"
export * from "./teacher-salary.vue?vue&type=script&lang=js"
import style0 from "./teacher-salary.vue?vue&type=style&index=0&id=47a04152&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a04152",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47a04152')) {
      api.createRecord('47a04152', component.options)
    } else {
      api.reload('47a04152', component.options)
    }
    module.hot.accept("./teacher-salary.vue?vue&type=template&id=47a04152&scoped=true", function () {
      api.rerender('47a04152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/teacher-salary.vue"
export default component.exports